// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"5406b22d","453":"73d779f7","529":"2d7145d6"}[chunkId] + ".chunk.js";
};